document.addEventListener('DOMContentLoaded', function () {
    // Cart Drawer Controller
    window.CartDrawer = {
        open: function () {
            const drawer = document.getElementById('CartDrawer');
            const backdrop = document.getElementById('CartDrawerBackdrop');
            if (drawer) {
                drawer.classList.remove('translate-x-full');
                drawer.classList.add('translate-x-0');
            }
            if (backdrop) backdrop.classList.remove('hidden');
            document.body.classList.add('overflow-hidden');
        },

        close: function () {
            const drawer = document.getElementById('CartDrawer');
            const backdrop = document.getElementById('CartDrawerBackdrop');
            if (drawer) {
                drawer.classList.remove('translate-x-0');
                drawer.classList.add('translate-x-full');
            }
            if (backdrop) backdrop.classList.add('hidden');
            document.body.classList.remove('overflow-hidden');
        },

        refresh: function () {
            return fetch(window.location.pathname + '?sections=cart-drawer')
                .then(response => response.json())
                .then(json => {
                    const drawer = document.getElementById('CartDrawer');
                    if (drawer && json['cart-drawer']) {
                        const parser = new DOMParser();
                        const doc = parser.parseFromString(json['cart-drawer'], 'text/html');
                        const newContent = doc.querySelector('#CartDrawerContent');
                        const currentContent = document.getElementById('CartDrawerContent');

                        if (newContent && currentContent) {
                            currentContent.innerHTML = newContent.innerHTML;
                        }
                    }
                });
        },

        addItem: function (variantId, quantity = 1, sellingPlanId = null) {
            const body = { id: variantId, quantity: quantity };
            if (sellingPlanId) {
                body.selling_plan = sellingPlanId;
            }

            return fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(body)
            })
                .then(response => {
                    if (!response.ok) {
                        return response.json().then(json => { throw json; });
                    }
                    return response.json();
                })
                .then(() => {
                    return this.refresh();
                })
                .then(() => {
                    this.open();
                });
        },

        updateItem: function (key, quantity) {
            return fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: key, quantity: quantity })
            })
                .then(response => response.json())
                .then(() => {
                    return this.refresh();
                });
        }
    };

    // Event Delegation for Cart Actions
    document.addEventListener('click', function (e) {
        // Open cart
        if (e.target.closest('[data-cart-open="true"]')) {
            e.preventDefault();
            CartDrawer.open();
        }

        // Close cart
        if (e.target.closest('[data-cart-close="true"]')) {
            e.preventDefault();
            CartDrawer.close();
        }

        // Refresh cart (for debugging or custom sync)
        if (e.target.closest('[data-cart-refresh="true"]')) {
            e.preventDefault();
            CartDrawer.refresh();
        }

        // Quantity update in drawer
        const qtyBtn = e.target.closest('[data-cart-update]');
        if (qtyBtn) {
            e.preventDefault();
            const key = qtyBtn.getAttribute('data-key');
            const action = qtyBtn.getAttribute('data-cart-update');
            const currentQty = parseInt(qtyBtn.getAttribute('data-qty'));
            const newQty = action === 'increase' ? currentQty + 1 : currentQty - 1;
            CartDrawer.updateItem(key, Math.max(0, newQty));
        }

        // Remove item in drawer
        const removeBtn = e.target.closest('[data-cart-remove]');
        if (removeBtn) {
            e.preventDefault();
            const key = removeBtn.getAttribute('data-key');
            CartDrawer.updateItem(key, 0);
        }
    });

    // Mobile Menu Toggle logic
    const mobileMenu = document.getElementById('MobileMenu');
    const menuBackdrop = document.getElementById('MobileMenuBackdrop');

    function openMobileMenu() {
        if (!mobileMenu) return;
        mobileMenu.classList.remove('-translate-x-full');
        mobileMenu.classList.add('translate-x-0');
        if (menuBackdrop) menuBackdrop.classList.remove('hidden');
    }

    function closeMobileMenu() {
        if (!mobileMenu) return;
        mobileMenu.classList.remove('translate-x-0');
        mobileMenu.classList.add('-translate-x-full');
        if (menuBackdrop) menuBackdrop.classList.add('hidden');
    }

    document.querySelectorAll('[data-menu-open="true"]').forEach((btn) => {
        btn.addEventListener('click', openMobileMenu);
    });

    document.querySelectorAll('[data-menu-close="true"]').forEach((btn) => {
        btn.addEventListener('click', closeMobileMenu);
    });

    // Close drawers on esc
    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
            CartDrawer.close();
            closeMobileMenu();
        }
    });

    console.log('BlumiBlends theme loaded');
});